import { render, staticRenderFns } from "./system-dialog.vue?vue&type=template&id=71632d14&"
import script from "./system-dialog.vue?vue&type=script&lang=ts&"
export * from "./system-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Dialog: require('/home/vsts/work/1/s/frontend/components/dialog.vue').default})
